import styled, { css } from 'styled-components';

import { COLORS } from '@theme/colors';
import { media } from '@theme/media';
import { Button } from '@components/form';

export const Text = styled.p`
  font-size: 13px;
  margin: 0;
`;

export const Info = styled(Text)`
  text-align: center;
  max-width: 380px;
  margin: 24px auto;
`;

export const Form = styled.form`
  width: 100%;
`;

const commonInputStyles = css`
  height: 34px;
  border-radius: 0;
  border: 0;
  background: ${COLORS.BLACK10};
  font-size: 13px;
  padding: 0 16px;
  color: black;
  display: block;
  width: 100%;

  &::-webkit-input-placeholder {
    color: ${COLORS.BLACK};
  }
`;

export const Email = styled.input.attrs({
  type: 'email',
  placeholder: 'Email address',
  required: true,
})`
  ${commonInputStyles};

  &::after {
    content: 'Required';
    display: flex;
    position: absolute;
    top: 50%;
    right: 16px;
    width: 100px;
    height: 100%;
    font-size: 13px;
    color: ${COLORS.BLACK20};
    justify-content: right;
    transform: translateY(-50%);
    pointer-events: none;
  }
`;

export const FieldWrapper = styled.div<{ isRequired?: boolean }>`
  position: relative;
  display: block;
  width: 100%;
  height: 34px;
  margin-bottom: 12px;

  &::after {
    content: '${({ isRequired }) => (isRequired ? 'Required' : 'Optional')}';
    display: flex;
    position: absolute;
    top: 50%;
    right: 16px;
    width: 100px;
    height: 100%;
    font-size: 13px;
    color: ${COLORS.BLACK20};
    justify-content: right;
    align-items: center;
    transform: translateY(-50%);
    pointer-events: none;
  }
`;

export const BottomRow = styled.div`
  display: flex;
  gap: 0;
  flex-direction: column;

  ${media.tablet} {
    gap: 12px;
    flex-direction: row;
  }
`;

export const FirstName = styled.input.attrs({
  type: 'text',
  placeholder: 'First name',
})`
  ${commonInputStyles};
`;

export const LastName = styled.input.attrs({
  type: 'text',
  placeholder: 'Last name',
})`
  ${commonInputStyles};
`;

export const SubmitButton = styled(Button).attrs({
  type: 'submit',
})`
  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      filter: contrast(0.3);
    `}
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  margin: 0 0 24px;
`;

export const Checkbox = styled.input.attrs({
  type: 'checkbox',
})`
  appearance: none;
  background-color: transparent;
  border: 1px solid ${COLORS.BLACK};
  box-shadow: none;
  padding: 0;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
  display: inline-block;
  position: relative;
  margin: 0 10px 0 0;

  ${media.tablet} {
    margin: 0 20px 0 0;
  }

  &:after {
    content: '';
    position: absolute;
    top: 3px;
    left: 3px;
    background-color: transparent;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    display: block;
    background-color: ${COLORS.BLACK};
    opacity: 0;
    transform: scale(0);
    transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;
  }

  &:checked {
    &:after {
      opacity: 1;
      transform: scale(1);
    }
  }
`;
